<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 18 18"
  >
    <g id="그룹_3764" data-name="그룹 3764" transform="translate(0 0)">
      <g id="그룹_3763" data-name="그룹 3763">
        <rect
          id="사각형_3736"
          data-name="사각형 3736"
          fill="#1772b9"
          width="18"
          height="18"
        />
      </g>
    </g>
    <path
      id="패스_1828"
      data-name="패스 1828"
      fill="#fff"
      d="M-1552.528,4719.79l-2.034,3.984-3.726-7.3-5.009,9.812h14.086Z"
      transform="translate(1565.254 -4710.878)"
    />
    <circle
      id="타원_618"
      data-name="타원 618"
      fill="#fff"
      cx="1.654"
      cy="1.654"
      r="1.654"
      transform="translate(12.292 2.722)"
    />
  </svg>
</template>
<script>
export default {
  props: {
    width: {
      type: Number,
      default: 18,
    },
    height: {
      type: Number,
      default: 18,
    },
  },
};
</script>
